module.exports = __webpack_public_path__ + "img/integralIcon3.def59a8b.png";